module.exports = __webpack_public_path__ + "img/far_night.65c776aa.jpg";